import { Link } from 'react-router-dom';
import { BarChart3, History } from 'lucide-react';

const ITEMS = [
  { icon: History, label: 'Hands', to: '/hand-history' },
  { icon: BarChart3, label: 'Wallet', to: '/transactions' },
];

export default function DesktopLeftSidebar() {
  return (
    <aside className="tp-floating-rail tp-floating-rail-left z-40 hidden xl:flex">
      {ITEMS.map(({ icon: Icon, label, to }) => (
        <Link key={label} to={to} className="tp-floating-glass-btn group" title={label}>
          <Icon size={20} className="text-tp-gold/85 transition group-hover:text-tp-gold group-hover:drop-shadow-[0_0_8px_rgba(212,175,55,0.5)]" />
          <span className="tp-floating-glass-label">{label}</span>
        </Link>
      ))}
    </aside>
  );
}
